// import coverImage from './images/bgr-gym-02.jpg';
import '../scss/coverimage.scss';

const CoverImage = () => {
  return (
    <div className="user-account-dashboard-cover-wrapper cover-image">
      {/* <img src={coverImage}></img> */}
    </div>
  )
}

export default CoverImage;